import { render, staticRenderFns } from "./PartnerManageModal.vue?vue&type=template&id=07c848ae&scoped=true"
import script from "./PartnerManageModal.vue?vue&type=script&lang=js"
export * from "./PartnerManageModal.vue?vue&type=script&lang=js"
import style0 from "./PartnerManageModal.vue?vue&type=style&index=0&id=07c848ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07c848ae",
  null
  
)

export default component.exports